import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/session`

export default {
  getStructure() {
    return ApiService.get(`${resourceUrl}/mainMenu`)
  },
  hasAccess(featureFlag) {
    return ApiService.get(`${resourceUrl}/access/${featureFlag}`)
  },
}
